import React from 'react'
import "../../CSS/About/amostraDeBebida.css";

type Props = {}

const AmostraDeBebida = (props: Props) => {
  return (
    <div className=' amostraDeBebida'>


    </div>
  )
}

export default AmostraDeBebida